import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { currentUserAtom, isAuthenticatedAtom } from "@/domains/auth/stores/currentUser";
import type { Role, User } from "@/domains/auth/api/types";

export function useCurrentUser(): User {
  return useAtomValue(currentUserAtom);
}

export function useCurrentRole(): Role {
  return useAtomValue(currentUserAtom).role;
}

export function useSetCurrentUser(): (user: User) => void {
  return useSetAtom(currentUserAtom);
}

export function useIsAuthenticated(): boolean {
  return useAtomValue(isAuthenticatedAtom);
}

export function useAuthSession(): {
  isAuthenticated: boolean;
  login: (user: User) => void;
  logout: () => void;
} {
  const [isAuthenticated, setIsAuthenticated] = useAtom(isAuthenticatedAtom);
  const setUser = useSetAtom(currentUserAtom);
  return {
    isAuthenticated,
    login: (user) => {
      setUser(user);
      setIsAuthenticated(true);
    },
    logout: () => setIsAuthenticated(false),
  };
}
